module.exports = __webpack_public_path__ + "img/17_100.c2c58018.png";